import { handleActions } from 'redux-actions'

import { disposeConference, setParticipantIdForUser } from '../actions/conference'

const defaultState: Record<number, string> = {}

export default handleActions<Record<number, string>, any>(
  {
    [setParticipantIdForUser.toString()](state, action) {
      const typedAction = action as ReturnType<typeof setParticipantIdForUser>

      const { userId, participantId } = typedAction.payload

      return { ...state, [userId]: participantId }
    },
    [disposeConference.toString()]() {
      return defaultState
    },
  },
  defaultState
)
